
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import HowItWorks from './components/HowItWorks';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SeoJsonLd from '../../components/SeoJsonLd';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  const localBusinessSchema = {
    '@context': 'https://schema.org',
    '@type': 'AutomotiveBusiness',
    '@id': `${siteUrl}/#business`,
    name: 'Mr. Auto Broker',
    description: 'AI-powered auto broker services in Woodbridge, Ontario. Save $3,500+ and 40 hours on your next vehicle purchase with access to 50+ dealerships.',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/634b5c78b437941165c49867ed9d7e99.jpeg',
    image: 'https://static.readdy.ai/image/5fb4188dc1db6e50d6c3e79cbe3ab0af/634b5c78b437941165c49867ed9d7e99.jpeg',
    email: 'izoom@me.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Woodbridge',
      addressRegion: 'ON',
      addressCountry: 'CA',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 43.7897,
      longitude: -79.6003,
    },
    areaServed: {
      '@type': 'State',
      name: 'Ontario',
    },
    priceRange: '$$',
    foundingDate: '2024',
    slogan: 'AI-Powered Car Buying',
    sameAs: [
      'https://www.facebook.com/kevin.schleifer',
      'https://www.linkedin.com/in/kevin-schleifer-0364aa1a/',
    ],
  };

  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${siteUrl}/#service`,
    serviceType: 'Auto Broker Service',
    provider: {
      '@id': `${siteUrl}/#business`,
    },
    areaServed: {
      '@type': 'State',
      name: 'Ontario',
    },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Auto Broker Services',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'AI-Powered Vehicle Search',
            description: 'Advanced AI technology to find your perfect vehicle across 50+ dealerships',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Expert Negotiation',
            description: 'Professional negotiation with executive-level dealership contacts',
          },
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'Complete Purchase Management',
            description: 'End-to-end vehicle purchase management and delivery coordination',
          },
        },
      ],
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'How much can I save using an auto broker in Woodbridge?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our clients save an average of $3,500 on their vehicle purchase. By leveraging executive relationships at 50+ dealerships across Ontario, we negotiate deals you cannot access alone.',
        },
      },
      {
        '@type': 'Question',
        name: 'How does AI-powered car buying work?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our AI technology analyzes your preferences and searches across 50+ dealerships to find your perfect vehicle. We then use our executive-level contacts to negotiate the best possible price on your behalf.',
        },
      },
      {
        '@type': 'Question',
        name: 'How long does the car buying process take with a broker?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We save you an average of 40+ hours. Instead of spending weeks visiting dealerships, our streamlined process handles everything from search to delivery, typically completing in just a few days.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do dealerships know I am working with a broker?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'No, the dealership never knows you are working with a broker, so you get the best possible price without any hassle or pressure tactics.',
        },
      },
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${siteUrl}/#website`,
    url: siteUrl,
    name: 'Mr. Auto Broker',
    description: 'AI-powered auto broker services in Woodbridge, Ontario',
    publisher: {
      '@id': `${siteUrl}/#business`,
    },
  };

  return (
    <>
      <SeoJsonLd data={localBusinessSchema} />
      <SeoJsonLd data={serviceSchema} />
      <SeoJsonLd data={faqSchema} />
      <SeoJsonLd data={websiteSchema} />
      
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <About />
        <HowItWorks />
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
